import intro from '../pages/intro/page.js';
import outro from '../pages/outro/page.js';
import game from '../pages/what_should_you_do/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'',
	header:'What should you&nbsp;do?',
	desc:[
		'Alligators are often seen near Georgia\'s Okefenokee Swamp.',
		'This means you really need to watch the road and not get distracted in the car!'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=()=>outro.show({
	cls:'what_should_you_do',
	header:'CONGRATS!',
	desc:[
		'You stayed focused and ignored all driving distractions, arriving at Okefenokee Swamp safely!'
	],
	parent,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
})

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
